import { useState } from "react"

// handles loading state for a fn that returns a promise
const useLoadingState = (fn) => {
  const [loading, setLoading] = useState(false)

  const wrapperFn = async (...args) => {
    setLoading(true)
    try {
      await fn(...args)
    } catch (error) {
      throw error
    } finally {
      setLoading(false)
    }
  }

  return [wrapperFn, loading]
}

export default useLoadingState
